import { render } from "./product-banner-area.vue?vue&type=template&id=ad633022&scoped=true"
import script from "./product-banner-area.vue?vue&type=script&lang=js"
export * from "./product-banner-area.vue?vue&type=script&lang=js"

import "./product-banner-area.vue?vue&type=style&index=0&id=ad633022&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad633022"]])

export default __exports__